// import { createAsyncThunk } from '@reduxjs/toolkit';
import { ExposureOutlined } from '@mui/icons-material';
import axios from 'axios';
const apiUrl = "https://reporte.incolabcolombia.com.co"
// const apiUrl = "http://localhost:3003"
// const apiUrl = "http://10.0.2.67:3001";
const apiUrlfir = "https://verificacion.incolabcolombia.com.co/api/documentos";

export const GET_USER = "GET_USER";
export const GET_REFEST = "GET_REFEST";
export const GET_REFXID = 'GET_REFXID';
export const GET_USERS_ERROR = "GET_USERS";
export const GET_REFPLAN = 'GET_REFPLAN';
export const GET_FACTCAR = 'GET_FACTCAR';
export const GET_DISPOSITIVO = 'GET_DISPOSITIVO';
export const GET_TIPOBOLSA = 'GET_TIPOBOLSA';
export const GET_PERMISOSALL = 'GET_PERMISOSALL';
export const GET_UBICACION = 'GET_UBICACION';
export const GET_LUGAR = 'GET_LUGAR';
export const GET_CLIENTE = 'GET_CLIENTE';
export const GET_USUARIO = 'GET_USUARIO';
export const GET_AREA = 'GET_AREA';
export const GET_CARGO = 'GET_CARGO';
export const GET_ROL = 'GET_ROL';
export const GET_MATERIAL = 'GET_MATERIAL';
export const GET_NORMA = 'GET_NORMA';
export const GET_ESTADO = 'GET_ESTADO';
export const GET_REPORTES = 'GET_REPORTES';
export const GET_CERTIFICADO = 'GET_CERTIFICADO';
export const GET_PERMISO_ID = 'GET_PERMISO_ID';
export const GET_USUARIOMUETRE = 'GET_USUARIOMUETRE';
export const GET_ALLREGREF = 'GET_ALLREGREF';
export const GET_REFPLANALL = 'GET_REFPLANALL';


export const getUsuario = (cedula, contrasena) => {
  return async function (dispatch) {
    try {
      const response = await axios.post(`${apiUrl}/login`, { cedula, contrasena });

      const { token, id, email, nombre, activo, Idarea, Idrol } = response.data;

      // Guardar datos en localStorage
      if (token) {
        sessionStorage.setItem("Esttoken", "TokenValido");
      } else {
        sessionStorage.setItem("Esttoken", "TokenInvalido");
      }
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("userId", id);
      sessionStorage.setItem("userEmail", email);
      sessionStorage.setItem("userNombre", nombre);
      sessionStorage.setItem("userActivo", activo);
      sessionStorage.setItem("Idarea", Idarea);
      sessionStorage.setItem("Idrol", Idrol);

      return dispatch({
        type: GET_USER,
        payload: response.data,
      });
    } catch (error) {
      let errorMessage = "Error en la autenticación";

      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      }

      return dispatch({
        type: GET_USERS_ERROR,
        payload: errorMessage,
      });
    }
  };
};

export const getrefest = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/estrefgen`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      // console.log("📡 Respuesta de la API:", response.data);
      return dispatch({
        type: GET_REFEST,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener el estado de referencia general:", error);
    }
  };
};

export const getrefid = (Idref) => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getregref?Idref=${Idref}`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_REFXID,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener el estado de referencia general:", error);
    }
  };
};

export const getRefplan = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getrefplan`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_REFPLAN,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener el estado de referencia del plan:", error);
    }
  };
};

export const getPermisosall = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/permisoalluser`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_PERMISOSALL,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener los permisos:", error);
    }
  };
};

export const getFactor = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getfactor`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_FACTCAR,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener el factor de carga:", error);
    }
  };
};

export const getDispositivo = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getdispositivo`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_DISPOSITIVO,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener el dispositivo:", error);
    }
  };
};

export const getTipobolsa = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/gettipobolsa`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_TIPOBOLSA,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener el tipo de bolsa:", error);
    }
  };
};

export const postPlanm = (plan) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      await axios.post(`${apiUrl}/postplan`, plan, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar el plan:", error);
    }
  };
};

export const actualizarPermisos = (permisosActualizados) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");

      await axios.put(`${apiUrl}/putpermiso`, permisosActualizados, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });

      // console.log("Permisos actualizados exitosamente.");
    } catch (error) {
      console.error("Error al actualizar permisos:", error);
    }
  };
};

export const getUbicacion = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getubicacion`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_UBICACION,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener las ubicaciones:", error);
    }
  };
};

export const postUbicacion = (nombre) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");

      await axios.post(`${apiUrl}/postubicacion`, { nombre }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar la ubicación:", error);
      throw error; // para que el componente lo pueda manejar en el catch
    }
  };
};

export const postlugar = (nombre) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");

      await axios.post(`${apiUrl}/postlugar`, { nombre }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar el lugar:", error);
      throw error; // para que el componente lo pueda manejar en el catch
    }
  };
};
export const getlugar = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getlugar`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_LUGAR,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener las ubicaciones:", error);
    }
  };
};

export const postFactor = (nuevoFactor) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      await axios.post(`${apiUrl}/creafactor`, nuevoFactor, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar el factor de carga:", error);
    }
  };
};

export const postDispositivo = (dispositivo) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      await axios.post(`${apiUrl}/creadispositivo`, dispositivo, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar el dispositivo:", error);
    }
  };
};

export const postBolsa = (bolsa) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      await axios.post(`${apiUrl}/postbolsa`, bolsa, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar la bolsa:", error);
    }
  };
};

export const getCliente = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getclien`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_CLIENTE,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener clientes:", error);
    }
  };
};

export const postCliente = (cliente) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      await axios.post(`${apiUrl}/postcliente`, cliente, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar el cliente:", error);
    }
  };
};

export const putCliente = (cliente) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      await axios.put(`${apiUrl}/putcliente`, cliente, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar la actualización cliente:", error);
    }
  };
};

export const getUsuarios = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getusuario`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_USUARIO,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
    }
  };
};

export const putUsuario = (usuario) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      await axios.put(`${apiUrl}/actualusuario`, usuario, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar la actualización usuario:", error);
    }
  };
};

export const postUsuario = (usuario) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      await axios.post(`${apiUrl}/postusuario`, usuario, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    } catch (error) {
      console.error("Error al enviar el usuario:", error);
    }
  };
};

export const getAreas = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getarea`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_AREA,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener areas:", error);
    }
  };
};

export const getCargos = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getcargo`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_CARGO,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener roles", error);
    }
  };
};

export const getRoles = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getrol`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_ROL,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener cargos", error);
    }
  };
};

export const getMaterial = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getmaterial`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_MATERIAL,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener materiales", error);
    }
  };
};

export const getnorma = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getnorma`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_NORMA,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener materiales", error);
    }
  };
};

export const postReferencia = (referencia) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(`${apiUrl}/postreferencia`, referencia, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
      return response.data; // Devuelve la respuesta para que el componente la pueda usar
    } catch (error) {
      console.error("Error al enviar la referencia:", error);
      throw error; // <- Esto es clave para que el catch en el componente funcione
    }
  };
};

export const postMaterial = (mater) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(`${apiUrl}/postmaterial`, mater, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
      return response.data; // Devuelve la respuesta para que el componente la pueda usar
    } catch (error) {
      console.error("Error al enviar el material:", error);
      throw error; // <- Esto es clave para que el catch en el componente funcione
    }
  };
};


export const actualizarEstado = (Estado) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.put(`${apiUrl}/actualizaestreg`, Estado, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });

      // Retornar explícitamente el resultado
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Error al actualizar estado:", error);

      return {
        success: false,
        error: error.message,
      };
    }
  };
};

export const getReporteope = (veh) => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token");

      // Usar params para enviar datos en query
      const response = await axios.get(`${apiUrl}/reportveh`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: veh  // <-- ESTO ENVÍA {Idref, fechaInicio, fechaFin} en la URL
      });

      return dispatch({
        type: GET_REPORTES,
        payload: response.data
      });

    } catch (error) {
      console.error("Error al obtener los reportes:", error);
    }
  };
};

export const postArchivo = (archivo, coords = null) => {
  return async function () {
    try {
      const formData = new FormData();
      formData.append("archivo", archivo); // ✅ Backend espera "archivo"

      // ✅ Si vienen coordenadas del sello, adjuntarlas
      if (coords) {
        formData.append("selloBase64",      coords.selloBase64);
        formData.append("selloPage",        String(coords.page));
        formData.append("selloX",           String(coords.x));
        formData.append("selloY",           String(coords.y));
        formData.append("selloWidth",       String(coords.width));
        formData.append("selloHeight",      String(coords.height));
        formData.append("pageCanvasWidth",  String(coords.pageWidth));
        formData.append("pageCanvasHeight", String(coords.pageHeight));
      }

      const response = await axios.post(`${apiUrlfir}/firmar`, formData);
      // ✅ No se sobreescribe Content-Type para que Axios agregue el boundary automáticamente

      return response.data;
    } catch (error) {
      console.error("Error al enviar el archivo:", error.response?.data || error.message);
      throw error;
    }
  };
};

export const postVerificarArchivo = (archivo) => {
  return async function () {
    try {
      const formData = new FormData();
      formData.append("archivo", archivo); // mismo nombre que espera el backend

      const response = await axios.post(`${apiUrlfir}/verificar`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error al verificar el archivo:", error.response?.data || error.message);
      throw error;
    }
  };
};

export const postSavefirm = (saveData) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(`${apiUrl}/savecert`, saveData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
      return response.data; // Devuelve la respuesta para que el componente la pueda usar
    } catch (error) {
      console.error("Error al enviar datos del certificado:", error);
      throw error; // <- Esto es clave para que el catch en el componente funcione
    }
  };
};

export const getCertificado = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token");
      // console.log("TOKEN LEÍDO:", token);

      // console.log("API URL:", apiUrl);

      const response = await axios.get(`${apiUrl}/allcertificados`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({
        type: GET_CERTIFICADO,
        payload: response.data,
      });

    } catch (error) {
      console.error(
        "Error al obtener certificados:",
        error.response?.data || error.message
      );
    }
  };
};


export const getPermisoId = (Idusuario) => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // 🔑 Obtener el token
      const response = await axios.get(`${apiUrl}/permisoid/${Idusuario}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Enviar token en los headers
        },
      });

      return dispatch({
        type: GET_PERMISO_ID,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error al obtener el permiso por ID:", error);
    }
  };
};

export const getUsuariomuetre = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/getusuariomuestre`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_USUARIOMUETRE,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener cargos", error);
    }
  };
};

export const postDatlotes = (datlot) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.put(`${apiUrl}/actualizaregref`, datlot, {
        headers: {
          Authorization: `Bearer ${token}`
          // ❌ NO PONER Content-Type AQUÍ
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al enviar datos del lote:", error);
      throw error;
    }
  };
};


export const getallRegref = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token"); // Obtener el token de sessionStorage
      const response = await axios.get(`${apiUrl}/allregreferencia`, {
        headers: {
          Authorization: `Bearer ${token}` // Enviar el token en los headers
        },
      });
      return dispatch({
        type: GET_ALLREGREF,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener los registros de referencia", error);
    }
  };
};

export const updateDatlote = (formData) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(
        `${apiUrl}/acturegrefrencia`,
        formData,   // ✔️ SIN stringify
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error al enviar datos del lote:", error);
      throw error;
    }
  };
};


export const deleteDatlote = (id) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");

      const response = await axios.delete(`${apiUrl}/deldat`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: { id } // <-- body correcto en DELETE
      });

      return response.data;

    } catch (error) {
      console.error("Error al eliminar el registro:", error);
      throw error;
    }
  };
};

export const getRefplanall = () => {
  return async function (dispatch) {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${apiUrl}/getrefplanall`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      return dispatch({
        type: GET_REFPLANALL,
        payload: response.data
      });
    } catch (error) {
      console.error("Error al obtener todos los planes de muestreo:", error);
    }
  };
};

export const getorigenes = () => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${apiUrl}/getorigenes`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al obtener origenes:", error);
      throw error;
    }
  };
};

export const postorigenes = (origen) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(`${apiUrl}/postorigenes`, origen, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al crear origen:", error);
      throw error;
    }
  };
};

export const getidorigen = (datos) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(`${apiUrl}/getidorigen`, datos, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al validar estado del origen:", error);
      throw error;
    }
  };
};

export const getorigenparal = (Idref) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${apiUrl}/getorigenparal?Idref=${Idref}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al obtener orígenes paralelos:", error);
      throw error;
    }
  };
};

export const postparal = (formData) => {
  return async function () {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(`${apiUrl}/postparal`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al enviar registro paralelo:", error);
      throw error;
    }
  };
};

